import { UserDto } from '@act/shared/data-transfer-objects';
import { CollapsibleCard, IconLibrary } from '@act/storybook';
import { Skeleton, Typography } from '@mui/material';
import { Fragment, useEffect, useState } from 'react';
import HtmlDisplayer from 'react-components/components/html-displayer';
import useMemberSummaryFeedbackDialog from 'react-components/dialog-forms/hooks/use-member-summary-feedback-dialog';
import { LabeledDatum } from 'toolkit/styles/dataDisplay';
import { timeFormatter } from '@act/shared/utilities';

export interface MemberPortraitCardProps {
  member: UserDto;
  defaultClosed?: boolean;
  onToggle?: () => void;
}

const MemberPortraitCard = ({
  member,
  defaultClosed = false,
  onToggle,
}: MemberPortraitCardProps) => {
  const openMemberSummaryFeedbackDialog = useMemberSummaryFeedbackDialog();

  const [hadNegativeFeedback, setHadNegativeFeedback] =
    useState<boolean>(false);

  useEffect(() => {
    setHadNegativeFeedback(false);
  }, [member]);

  return (
    <CollapsibleCard
      title="Member portrait"
      actions={[
        {
          display: 'Send feedback',
          disabled: !member?.memberSummary,
          callback: () =>
            openMemberSummaryFeedbackDialog({
              member,
              memberSummary: member.memberSummary,
              handleCallback: e => setHadNegativeFeedback(e),
            }),
        },
      ]}
      avatar={<IconLibrary iconName="UserSquare" size={24} />}
      collapsible
      defaultClosed={defaultClosed}
      onToggle={onToggle}
    >
      {!member.memberSummary && <Typography>No record found</Typography>}
      {member?.memberSummary &&
        (hadNegativeFeedback ? (
          <Fragment>
            <Typography variant="bodyLarge" sx={{ marginBottom: 'px' }}>
              <Skeleton variant="text" animation="wave" width={'35%'} />
            </Typography>
            <Typography variant="bodyMedium" sx={{ lineHeight: '16px' }}>
              <Skeleton variant="text" animation="wave" height={24} />
            </Typography>
            <Typography variant="bodyMedium" sx={{ lineHeight: '16px' }}>
              <Skeleton variant="text" animation="wave" height={24} />
            </Typography>
            <Typography variant="bodyMedium" sx={{ lineHeight: '16px' }}>
              <Skeleton variant="text" animation="wave" height={24} />
            </Typography>
            <Typography variant="bodyMedium" sx={{ lineHeight: '16px' }}>
              <Skeleton
                variant="text"
                animation="wave"
                height={24}
                width={'95%'}
              />
            </Typography>
          </Fragment>
        ) : (
          <Fragment>
            <LabeledDatum
              label={`Summary Updated ${timeFormatter.epochToHumanReadableDate({
                date: member.memberSummary.lastUpdated,
              })}`}
              datum={
                <HtmlDisplayer innerHtml={member.memberSummary?.summary} />
              }
              variant={'bodyMedium'}
            />
          </Fragment>
        ))}
    </CollapsibleCard>
  );
};

export default MemberPortraitCard;
